module.exports = __webpack_public_path__ + "img/set-up-inventory.183cabb4.svg";